// ------------------------------------------------------------------------------------------------------------------ //
//
//  Accordion function

//  Needing follow attributes in html
//  - data-switch-layout='{"switch":"element_need_to_modified", "layout":"grid || list"}'
//
// ------------------------------------------------------------------------------------------------------------------ //


;(function ($, window, document, undefined) {
	'use strict';

	var Component = function (element, data) {
		this.$el = $(element);
		this.options = $.extend(true, Component.config, data);
	};

	Component.config = {
		class_prefix: 'layout--',
		class_is_active: 'is--active'
	};

	Component.prototype.switch = function () {
		// toggle the layout class (use alterClass to allow wildcards)

		$(this.options.switch)
			.parent()
			.find('.is--active')
			.removeClass('is--active');

		if (this.$el.hasClass(this.options.class_is_active)) {
			// remove active class as alternative for siblings() or toggleClass
			this.$el.removeClass(this.options.class_is_active);
		} else {
			$(this.options.switch)
				.addClass('is--active');

			// remove active class as alternative for siblings() or toggleClass
			$('[data-accordion]')
				.removeClass(this.options.class_is_active);

			// modify clicked element with a active class
			this.$el.addClass(this.options.class_is_active);
		}
	};

  $(function () {
    // console.log('jep')
    $('[data-accordion]').on('touchend click', function (ev) {

      var $component = $(this);
			var Cmpt = new Component($component, $component.data().accordion);
			Cmpt.switch();
			ev.preventDefault();
    });
  });

	// $(document).on('ready', function () {
  //   console.log('lalala');
	// 	$('[data-accordion]').on('touchend click', function (ev) {
  //     console.log('exist');
	// 		var $component = $(this);
	// 		var Cmpt = new Component($component, $component.data().accordion);
	// 		Cmpt.switch();
	// 		ev.preventDefault();
	// 	});
	// });

})(jQuery, window, document);

